(() => {
  if (customElements.get('b-worldwide')) return;

  class BWorldwide extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
      this.index = 0;
      this.sectionLoadHandler = this.handleSectionLoad.bind(this);
      this.blockSelectHandler = this.handleBlockSelect.bind(this);
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    }

    connectedCallback() {
      this.track = this.querySelector('.b-world__carousel-track');
      this.slides = this.track
        ? Array.from(this.track.querySelectorAll('.b-world__slide'))
        : [];
      this.delay = parseInt(this.dataset.autoplayDelay || '4000', 10);

      document.addEventListener('shopify:section:load', this.sectionLoadHandler);
      document.addEventListener('shopify:block:select', this.blockSelectHandler);

      if (this.slides.length <= 1) {
        this.show(0);
        return;
      }

      this.show(0);
      if (!this.reducedMotion.matches) {
        this.start();
      }
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('shopify:section:load', this.sectionLoadHandler);
      document.removeEventListener('shopify:block:select', this.blockSelectHandler);
    }

    start() {
      this.stop();
      if (this.slides.length <= 1 || this.reducedMotion.matches) return;
      this.timer = window.setInterval(() => {
        this.show(this.index + 1);
      }, this.delay);
    }

    stop() {
      if (!this.timer) return;
      clearInterval(this.timer);
      this.timer = null;
    }

    show(nextIndex) {
      if (!this.slides.length) return;
      const total = this.slides.length;
      this.index = ((nextIndex % total) + total) % total;

      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('b-world__slide--active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }

    handleSectionLoad(event) {
      if (event.detail && event.detail.sectionId && event.detail.sectionId !== this.dataset.sectionId) {
        return;
      }
      this.disconnectedCallback();
      this.connectedCallback();
    }

    handleBlockSelect(event) {
      if (!event.target || !this.contains(event.target)) return;
      const slide = event.target.closest('.b-world__slide');
      if (!slide) return;
      const index = this.slides.indexOf(slide);
      if (index < 0) return;
      this.stop();
      this.show(index);
    }
  }

  customElements.define('b-worldwide', BWorldwide);
})();
